import { useEffect } from "react"
import axios, { AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from "axios"
import { useSnapshot } from "valtio"
import { store } from "@/stores/stores"
import { toast } from "sonner"
import { clone, extractResponseErrorMessage } from "@/lib/utils"

// axios.defaults.withCredentials = true;

const getTokenHeader = () => {
  try {
    const session = JSON.parse(localStorage.getItem("session") || "{}")
    return {
      ...(session?.currentWorkspace?.token && {
        Authorization: `Bearer ${session?.currentWorkspace?.token}`,
      }),
    }
  } catch {
    return {}
  }
}


export const client = axios.create({
  baseURL: (import.meta.env.VITE_API_URL || "https://hado-p4lf4.ondigitalocean.app") + "/v1",
  headers: {
    "Content-Type": "application/json",
    ...getTokenHeader(),
  },
})

export const updateClient = () => {
  client.defaults.headers = {
    ...client.defaults.headers,
    ...getTokenHeader(),
  }
}

client.interceptors.response.use(
  (response) => {
    printRequestResponse(response)
    return response
  },
  (error) => {
    printRequestResponse(error.response, {
      showHeaders: true,
      isError: true,
      request: error.request,
      config: error.config,
    })

    if (error.response && error.response.status === 401) {
      store.session.actions.logout()
    } else {
      toast.error(extractResponseErrorMessage(error))
    }

    return Promise.reject(error)
  },
)

// ██╗  ██╗ ██████╗  ██████╗ ██╗  ██╗
// ██║  ██║██╔═══██╗██╔═══██╗██║ ██╔╝
// ███████║██║   ██║██║   ██║█████╔╝
// ██╔══██║██║   ██║██║   ██║██╔═██╗
// ██║  ██║╚██████╔╝╚██████╔╝██║  ██╗
// ╚═╝  ╚═╝ ╚═════╝  ╚═════╝ ╚═╝  ╚═╝
//
// let interceptorAdded = false
export const useClientInit = () => {
  const snap = useSnapshot(store)
  const access_token = snap.session?.currentWorkspace?.token

  // useEffect(() => {
  //   if (interceptorAdded) return
  //   interceptorAdded = true

  //   client.interceptors.response.use(
  //     (response) => {
  //       printRequestResponse(response)
  //       return response
  //     },
  //     (error) => {
  //       printRequestResponse(error.response, {
  //         showHeaders: true,
  //         isError: true,
  //         request: error.request,
  //         config: error.config,
  //       })

  //       console.log("error", error)

  //       if (error.response && error.response.status === 401) {
  //         store.session.actions.logout()
  //       } else {
  //         // TODO: Show error toast
  //         toast.error({ message: extractResponseErrorMessage(error) })
  //       }

  //       return Promise.reject(error)
  //     },
  //   )
  // }, [])

  useEffect(() => {
    if (access_token) {
      client.defaults.headers.common["Authorization"] = `Bearer ${access_token}`
    } else {
      delete client.defaults.headers.common["Authorization"]
    }
  }, [access_token])
}

// ██████╗ ██████╗ ██╗███╗   ██╗████████╗
// ██╔══██╗██╔══██╗██║████╗  ██║╚══██╔══╝
// ██████╔╝██████╔╝██║██╔██╗ ██║   ██║
// ██╔═══╝ ██╔══██╗██║██║╚██╗██║   ██║
// ██║     ██║  ██║██║██║ ╚████║   ██║
// ╚═╝     ╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝   ╚═╝
//
const printRequestResponse = (
  response: AxiosResponse<any, any>,
  opts?: {
    showHeaders: true
    isError?: boolean
    config?: InternalAxiosRequestConfig<any>
    request: AxiosRequestConfig<any>
  },
) => {
  let sent
  const config = response?.config || opts?.config
  try {
    sent = typeof config.data === "string" ? JSON.parse(config.data) : config.data
  } catch {
    sent = config?.data || "No response from server"
  }
  const method = config?.method?.toUpperCase()

  let color = "#f1c40f"
  if (method === "GET") {
    color = "#f1c40f"
  } else if (method === "POST") {
    color = "#2ecc71"
  } else if (method === "PATCH") {
    color = "#3498db"
  } else if (method === "DELETE") {
    color = "#e74c3c"
  }

  if (opts?.isError) {
    color = "#e74c3c"
  }

  // console.log('🚀 Request Response', response)
  console.group(`%c${opts?.isError ? "🚩🚩 [ERROR] " : ""}[${method}] ` + config.url, `color: ${color}; background-color: black`)
  console.log("Enviado: ", sent || "-")
  console.log("Recebido: ", response?.data ? clone(response?.data) : "-")
  if (opts?.showHeaders) {
    console.log("Headers: ", JSON.parse(JSON.stringify(config.headers || {}, null, 2)))
  }
  console.groupEnd()
}

// mock.onPatch(new RegExp(`/channels/*`)).reply((config) => {
//   const id = config.url?.split('/').pop()
//   return [
//     200,
//     {
//       ...JSON.parse(config.data),
//       id,
//       _id: id,
//     },
//   ]
// })
